import React, { useState } from 'react';
import { Cloud, Search, Save } from 'lucide-react';

export const ForwardingDomain: React.FC = () => {
  const [domainSearch, setDomainSearch] = useState('');
  const [newForwardingDomain, setNewForwardingDomain] = useState('');

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Update Forwarding Domain on Cloudflare</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Update the forwarding domain configuration for users on Cloudflare
        </p>
      </div>

      <div className="card-modern p-6 space-y-6">
        <div>
          <h2 className="text-lg font-semibold mb-4">Find User Domain</h2>
          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium mb-2 block">
                Search by Domain or Email
              </label>
              <div className="flex gap-3">
                <div className="relative flex-1">
                  <input
                    type="text"
                    value={domainSearch}
                    onChange={(e) => setDomainSearch(e.target.value)}
                    className="input-modern h-10 w-full px-3 text-sm"
                    placeholder="Enter domain name or user email..."
                  />
                </div>
                <button className="btn-primary px-4 py-2 rounded-lg font-medium flex items-center space-x-2">
                  <Search className="h-4 w-4" />
                  <span>Search</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-border pt-6">
          <h2 className="text-lg font-semibold mb-4">Update Configuration</h2>
          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium mb-2 block">
                Current Forwarding Domain
              </label>
              <div className="p-3 bg-muted rounded-lg text-sm">
                forward.example.com
              </div>
            </div>

            <div>
              <label className="text-sm font-medium mb-2 block">
                New Forwarding Domain
              </label>
              <input
                type="text"
                value={newForwardingDomain}
                onChange={(e) => setNewForwardingDomain(e.target.value)}
                className="input-modern h-10 w-full px-3 text-sm"
                placeholder="Enter new forwarding domain..."
              />
            </div>

            <div className="flex items-center justify-between pt-4">
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Cloud className="h-4 w-4" />
                <span>Connected to Cloudflare API</span>
              </div>
              <button className="btn-primary px-4 py-2 rounded-lg font-medium flex items-center space-x-2">
                <Save className="h-4 w-4" />
                <span>Update Domain</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="card-modern p-4 bg-amber-500/10 border border-amber-500/20">
        <p className="text-sm text-amber-600 dark:text-amber-400">
          <strong>Note:</strong> Changes to forwarding domains will take effect immediately on Cloudflare.
          Ensure DNS propagation time is considered.
        </p>
      </div>
    </div>
  );
}; 